(function () {
  function countText(directory, key, count) {
    var template = directory.dataset[key] || "";
    return template.replace("[count]", count);
  }

  function initDirectory(directory) {
    if (directory.dataset.dxoReady === "true") return;
    directory.dataset.dxoReady = "true";

    var input = directory.querySelector("[data-dxo-country-search]");
    if (!input) return;

    var cards = Array.prototype.slice.call(directory.querySelectorAll("[data-dxo-country]"));
    var count = directory.querySelector("[data-dxo-country-count]");
    var empty = directory.querySelector("[data-dxo-country-empty]");
    var reset = directory.querySelector("[data-dxo-country-reset]");

    function update() {
      var query = input.value.trim().toLocaleLowerCase();
      var visible = 0;

      cards.forEach(function (card) {
        var match = !query || (card.dataset.search || "").indexOf(query) !== -1;
        card.hidden = !match;
        if (match) visible += 1;
      });

      if (count) {
        count.textContent = visible === 0
          ? countText(directory, "countNone", visible)
          : countText(directory, visible === 1 ? "countOne" : "countMany", visible);
      }
      if (empty) empty.hidden = visible !== 0;
      if (reset) reset.hidden = query.length === 0;
    }

    input.addEventListener("input", update);
    if (reset) {
      reset.addEventListener("click", function () {
        input.value = "";
        update();
        input.focus();
      });
    }
    update();
  }

  function initRoot(root) {
    if (root.dataset.dxoReady === "true") return;
    root.dataset.dxoReady = "true";
    root.querySelectorAll("[data-dxo-directory]").forEach(initDirectory);

  }

  function init(scope) {
    var context = scope || document;
    context.querySelectorAll("[data-dxo-root]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) { init(event.target); });
})();
